require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/slider.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/slider.legacy.js
// module id = 628
// module chunks = 31